import TransposePlugin from './TransposePlugin';

export default TransposePlugin;
